var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11968_108418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51172 3.50928H132.826V73.6786H127.885L127.813 8.52144H8.52388V81.6991H31.5783V86.7112H3.51172V3.50928Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.813 27.6172L8.52388 27.5679V22.5557H127.813V27.6172Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.813 41.6018H8.52388V36.5896H127.813V41.6018Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1236 57.6405H20.0506V52.6283H50.1236V57.6405Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1236 69.6699H20.0506V64.6577H50.1236V69.6699Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5783 73.6786H160.892V156.88H31.5783V73.6786ZM36.5904 78.6907V151.868H155.88V78.6907H36.5904Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2343 134.326C106.753 134.326 115.281 125.798 115.281 115.279C115.281 104.761 106.753 96.2332 96.2343 96.2332C85.7154 96.2332 77.1881 104.761 77.1881 115.279C77.1881 125.798 85.7154 134.326 96.2343 134.326ZM96.2343 139.338C109.521 139.338 120.293 128.567 120.293 115.279C120.293 101.992 109.521 91.2211 96.2343 91.2211C82.9472 91.2211 72.1759 101.992 72.1759 115.279C72.1759 128.567 82.9472 139.338 96.2343 139.338Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6199 91.2202H60.6516V96.2324H52.6321V134.826H60.6516V139.838H47.6199V91.2202Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.856 139.839H131.824V134.827H139.844V96.2333H131.824V91.2212H144.856V139.839Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3983 126.404H97.1305V123.469C100.523 123.108 102.664 121.063 102.664 118.224C102.664 115.962 101.293 114.591 98.2853 113.701L97.1305 113.364V110.236C98.5981 110.381 100.21 110.934 101.244 111.608L102.399 108.023C101.244 107.422 99.2476 106.844 97.1305 106.748V104.799H95.3983V106.772C91.6692 107.109 89.7927 109.226 89.7927 111.824C89.7927 114.086 91.0437 115.553 93.5939 116.251L95.3983 116.732V120.052C93.7623 119.908 92.1023 119.21 90.9956 118.464L90.0573 122.121C91.0437 122.675 93.1609 123.42 95.3983 123.517V126.404ZM93.9067 111.536C93.9067 110.91 94.3638 110.429 95.3983 110.26V112.835C94.3878 112.546 93.9067 112.257 93.9067 111.536ZM98.5259 118.513C98.5259 119.186 98.0447 119.715 97.1305 119.956V117.237C98.0207 117.526 98.5259 117.911 98.5259 118.513Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2071 64.6815C97.1498 64.6815 98.7247 63.1066 98.7247 61.1638C98.7247 59.2211 97.1498 57.6462 95.2071 57.6462C93.2643 57.6462 91.6895 59.2211 91.6895 61.1638C91.6895 63.1066 93.2643 64.6815 95.2071 64.6815ZM95.2071 69.6815C99.9112 69.6815 103.725 65.868 103.725 61.1638C103.725 56.4597 99.9112 52.6462 95.2071 52.6462C90.5029 52.6462 86.6895 56.4597 86.6895 61.1638C86.6895 65.868 90.5029 69.6815 95.2071 69.6815Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.707 64.6815C109.65 64.6815 111.225 63.1066 111.225 61.1638C111.225 59.2211 109.65 57.6462 107.707 57.6462C105.764 57.6462 104.189 59.2211 104.189 61.1638C104.189 63.1066 105.764 64.6815 107.707 64.6815ZM107.707 69.6815C112.411 69.6815 116.225 65.868 116.225 61.1638C116.225 56.4597 112.411 52.6462 107.707 52.6462C103.003 52.6462 99.1895 56.4597 99.1895 61.1638C99.1895 65.868 103.003 69.6815 107.707 69.6815Z",
    fill: "#0C2487"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11968_108418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.a6416336c26610bec032f461c9bb7bd7.svg";
export { ForwardRef as ReactComponent };